import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../layout/header";
import Footer from "../../layout/footer";
import MetaTags from "../../element/MetaTags";
import Menu from "./components/menu";
const bg = require("../../../images/servicehero.png");

class WindowCleaning extends Component {
  render() {
    return (
      <>
        <MetaTags
          title="Window Cleaning"
          description="Window Cleaning"
          keywords="Window Cleaning"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">Window Cleaning</h1>
                <div className="breadcrumb-row">
                  {/* <ul className="list-inline">
                    <li>
                      <Link  onClick={() => { window.scrollTo({ top: 0, left: 0, behavior: "auto" })}} to="/">Home</Link>
                    </li>
                    <li>Service</li>
                    <li>Service Details</li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <Menu />
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className=" col-md-12 m-b30">
                      <div className="dlab-box">
                        {/* <div className="dlab-media">
                            {" "}
                            <Link to="#">
                              <img
                                src={require("../../images/about/pic3.jpg")}
                                alt=""
                              />
                            </Link>{" "}
                          </div> */}
                        <div className="dlab-info ">
                          <h4 className="dlab-title m-t0">
                            <Link to="#">
                              Get Smudge-free Windows with the Help of
                              Professional Cleaning Services at Gold Coast, QLD
                            </Link>
                          </h4>
                          <p>
                            If you're a homeowner or a business owner looking to
                            clean your windows effectively, you might need help
                            knowing where to begin.
                          </p>
                          <p>
                            You can get expert outcomes by using the appropriate
                            tools. Professional window cleaning uses advanced
                            tools and techniques to bring you the spot-free
                            sparkly windows you crave.
                          </p>
                        </div>
                        <div className="dlab-info m-t30 ">
                          <h4 className="dlab-title m-t0">
                            <Link to="#">
                              Benefits of Hiring a Professional Window Cleaning
                              Service?
                            </Link>
                          </h4>
                          <p>
                            Professional window cleaners use professional-grade
                            tools and certified cleaning solutions to attain
                            smudge-free results and can clean small to large
                            windows inside and outside residences and commercial
                            buildings. It's crucial to understand that the best
                            method for cleaning inside windows differs from the
                            best method for cleaning outside windows.
                          </p>
                          <p>
                            Scrubber and squeegee are the undisputed winning
                            tool combination for cleaning inside windows. This
                            combination is quick and efficient. Many experts
                            prefer a water-fed pole configuration to squeegee
                            and scrubbing equipment for washing outdoor windows.
                            A water-fed pole is better for cleaning windows out
                            of reach because it is more expensive, requires a
                            water tank and pump, and is trickier. It is why you
                            should leave it to an expert window cleaning
                            service. You might assume it is easier to clean
                            unreachable windows with the most typical type of
                            water-fed pole cleaner with an extendable pole.
                            However, this setup requires a significant
                            investment in materials and training to simplify the
                            process.
                          </p>
                          <p>
                            The second most popular choice is a set of
                            pole-mounted squeegee and scrubber tools.
                            Professionals may successfully use this equipment on
                            poles up to 30 or 40 feet long. They may use a
                            variety of window cleaning tools; nevertheless, to
                            achieve outstanding results, it is the technique
                            that is necessary to gain professional results.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="dlab-box">
                      <div className="dlab-info m-t30">
                        <h4 className="dlab-title m-t0">
                          <Link to="#">
                            Cost-Effective Window Cleaning Services in Gold
                            Coast, Queensland
                          </Link>
                        </h4>
                        <p>
                          Wish your home or place of business had streak-free
                          windows? Contact Gold Coast Kangaroo Shine Property
                          Services in Gold Coast to have your home or business
                          windows cleaned. Being dependable, punctual, and
                          cost-effective makes our team stand out. Our team of
                          professionals at Gold Coast Kangaroo Shine Property
                          Services in Gold Coast will provide a spectacular
                          service and leave you with spotless windows. Call us
                          at +61424888804 to get a free quote!
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}
export default WindowCleaning;
